
import Component, { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import FilialeHeader from "../custom/FilialeHeader.vue"
import TischbestellungStartenLogic from "@/logic/bestellung_neu/tischbestellung_starten_logic"
import Bestellung from "@/entities/common/bestellung"
import BestellungRow from "../custom/BestellungRow.vue"
import BestellungRowAbholung from "../custom/BestellungRowAbholung.vue"
import BestellungRowLieferung from "../custom/BestellungRowLieferung.vue"
import BestelllungRowSofort from "../custom/BestellungRowSofort.vue"

@Component({
  components: {
    FilialeHeader,
    BestellungRow,
    BestellungRowAbholung,
    BestellungRowLieferung,
    BestelllungRowSofort,
  },
})
export default class TischbestellungStarten extends mixins(Calculator) {
  logic: TischbestellungStartenLogic = null

  mounted() {
    this.logic = new TischbestellungStartenLogic()
    this.logic.init(this.$route.params.id)
  }

  bestellungStarten() {
    this.logic.bestellungStarten()
  }

  bestellungAnzeigen(bestellung: Bestellung) {
    this.logic.bestellungAnzeigen(bestellung)
  }
}
